export function diffRows(previous, current, key) {
    const previousByKey = indexRows(previous, key);
    const currentByKey = indexRows(current, key);
    const added = [];
    const updated = [];
    const deleted = [];
    for (const row of current) {
        const rowKey = key(row);
        if (!previousByKey.has(rowKey)) {
            added.push(row);
        }
        else if (!structurallyEqual(previousByKey.get(rowKey), row)) {
            updated.push(row);
        }
    }
    for (const row of previous) {
        if (!currentByKey.has(key(row)))
            deleted.push(row);
    }
    return { added, deleted, updated };
}
function indexRows(rows, key) {
    const rowsByKey = new Map();
    for (const row of rows) {
        const rowKey = key(row);
        if (rowsByKey.has(rowKey))
            throw new Error(`Live query rows must have unique keys: ${rowKey}`);
        rowsByKey.set(rowKey, row);
    }
    return rowsByKey;
}
function structurallyEqual(left, right) {
    if (Object.is(left, right))
        return true;
    if (typeof left !== "object" || left === null || typeof right !== "object" || right === null)
        return false;
    if (Array.isArray(left) || Array.isArray(right)) {
        return Array.isArray(left)
            && Array.isArray(right)
            && left.length === right.length
            && left.every((item, index) => structurallyEqual(item, right[index]));
    }
    const leftRecord = left;
    const rightRecord = right;
    const leftKeys = Object.keys(leftRecord);
    const rightKeys = Object.keys(rightRecord);
    return leftKeys.length === rightKeys.length
        && leftKeys.every((key) => Object.hasOwn(rightRecord, key) && structurallyEqual(leftRecord[key], rightRecord[key]));
}
//# sourceMappingURL=diff.js.map